module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_f_albino.db153dc2.png";